// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__b6oGM","name":"Header_name__tZLYW","birthday":"Header_birthday__3cPOr","skeleton":"Header_skeleton__1J-HO"};